import React from "react";
import { Card, Button } from "react-bootstrap";
import ProjectCard from "./ProjectCard";
// import ProjectCard from "./ProjectCard";

export default function ProjectColumn({
  title,
  projects,
  onAdd,
  onEdit,
  onDelete
}){

return(

<div className="mt-3" style={{background:"#f3f4f6",padding:10,borderRadius:10}}>

<div className="d-flex justify-content-between mb-2">

<h6>{title}</h6>
<span className="badge bg-light">{projects.length}</span>

</div>

{projects.map(p=>(
<ProjectCard
key={p.id}
project={p}
onEdit={()=>onEdit(p)}
onDelete={()=>onDelete(p)}
/>
))}

<Button
variant="light"
className="w-100 border mt-2"
onClick={onAdd}
>
+ New Project
</Button>

</div>

)
}